import createReducer from '../createReducer';

const initialState = {
    whatsAppTemplates: [],
    getWhatsAppTemplatesXHR: null,
    createWhatsAppTemplateXHR: null,
    updateWhatsAppTemplateXHR: null
};

const reducer = createReducer('appPlus', initialState);

export default reducer;
